import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredMarkAsteriskDirective } from './required/required-mark-asterisk.directive';
import { ClickOutsideDirective } from './click-outside/click-outside.directive';

@NgModule({
  declarations: [
    RequiredMarkAsteriskDirective,
    ClickOutsideDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RequiredMarkAsteriskDirective,
    ClickOutsideDirective,
  ]
})
export class DirectivesModule { }
